var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLg = function SvgLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0019 24C14.3757 24 16.6961 23.2961 18.6698 21.9773C20.6435 20.6585 22.1819 18.7841 23.0903 16.591C23.9987 14.3979 24.2363 11.9848 23.7732 9.65662C23.3101 7.32848 22.1671 5.18994 20.4886 3.51144C18.8101 1.83294 16.6715 0.68987 14.3434 0.226774C12.0152 -0.236323 9.60205 0.00135517 7.40899 0.909752C5.21592 1.81815 3.34148 3.35646 2.02269 5.33017C0.703901 7.30387 0 9.62432 0 11.9981C0 15.1812 1.26448 18.2339 3.51528 20.4847C5.76608 22.7355 8.81882 24 12.0019 24Z",
    fill: "#A50034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7722 12.225C20.6528 16.9673 16.7711 20.775 12 20.775C7.1537 20.775 3.225 16.8463 3.225 12C3.225 7.1537 7.1537 3.225 12 3.225V2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3096 21.75 21.6279 17.5059 21.7475 12.225H21.75V11.25H15V12.225H20.7722Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 8.25,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.225 6.75H11.25V17.25H15V16.275H12.225V6.75Z",
    fill: "white"
  })));
};
export default SvgLg;